import { ActivatedRoute, Router } from '@angular/router';
import {
  AfterViewChecked,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from 'src/app/core/services/auth.service';
import { Profile } from 'src/app/core/entities/profile.entity';
import { ProfileService } from 'src/app/core/services/profile.service';
import { SettingsModalComponent } from 'src/app/account/settings-modal/settings-modal.component';
import { professionalTitleMapping } from 'src/app/core/enums/professional-title';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewChecked {
  @ViewChild('header') header: ElementRef;
  public showBackList = false;
  public me: Profile;
  public professionalTitleMapping = professionalTitleMapping;

  constructor(
    public authService: AuthService,
    private router: Router,
    private renderer2: Renderer2,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    if (this.router.url.includes('/patients/detail')) {
      this.showBackList = true;
    }

    this.me = this.profileService.me;
  }

  ngAfterViewChecked(): void {
    this.onResize();
  }

  @HostListener('window:resize', [])
  onResize() {
    const height = `${this.header.nativeElement.offsetHeight}px`;
    this.renderer2.setStyle(document.body, 'padding-top', height);
  }

  openSettings() {
    const modalRef = this.modalService.open(SettingsModalComponent, {
      backdrop: 'static',
      windowClass: 'settings-modal',
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/sign-in');
    return false;
  }

  back() {
    this.router.navigate(['list'], { relativeTo: this.route });
  }
}
